<template>
  <div>
    <h2>日誌アラート設定</h2>

    <div class="pt-6">
      <v-alert color="primary" type="info" variant="outlined" density="compact">
        承認時に記入漏れがある場合、アラートを表示するクラスを選択してください。
      </v-alert>
    </div>

    <v-container class="pt-10">
      <v-row>
        <h4>クラス日誌</h4>
      </v-row>
      <v-row>
        <v-col cols="6" align-self="center">
          <h5>クラス</h5>
        </v-col>
        <v-col cols="6" align-self="center">
          <v-select
            v-model="input.classDiaryConfirmation.targetClassIds"
            :item-title="(item) => item.year + '年度 ' + item.className"
            item-value="classId"
            :items="classes"
            chips
            multiple
            variant="outlined"
            density="compact"
            hide-details
            :readonly="isLoading"
            color="primary"
          ></v-select>
        </v-col>
      </v-row>
    </v-container>

    <v-container class="pt-8">
      <v-row>
        <h4>園日誌</h4>
      </v-row>
      <v-row>
        <v-col cols="6" align-self="center">
          <h5>クラス</h5>
        </v-col>
        <v-col cols="6" align-self="center">
          <v-select
            v-model="input.schoolDiaryConfirmation.targetClassIds"
            :item-title="(item) => item.year + '年度' + item.className"
            item-value="classId"
            :items="classes"
            chips
            multiple
            variant="outlined"
            density="compact"
            hide-details
            :readonly="isLoading"
            color="primary"
          ></v-select>
        </v-col>
      </v-row>
    </v-container>

    <div class="d-flex justify-center pt-12">
      <v-btn
        @click="updateDiarySetting"
        :loading="isLoading"
        color="primary"
        variant="flat"
        large
        >保存
      </v-btn>
    </div>
  </div>
</template>

<script lang="ts">
import LocalDataService from "@/service/LocalDataService";
import { classModule } from "@/store/dataModules/classModule";
import { NurseryClassResponse } from "chaild-api/lib";
import { diarySettingModule } from "@/store/dataModules/diarySettingModule";
import { defineComponent } from "vue";

export default defineComponent({
  name: "DiarySetting",

  async mounted() {
    await this.listClasses();
    await this.listDiarySetting();
  },

  data() {
    return {
      isLoading: false,
      ageItems: [0, 1, 2, 3, 4, 5],
      input: {
        classDiaryConfirmation: {
          targetClassIds: [],
          targetAges: [],
        },
        schoolDiaryConfirmation: {
          targetClassIds: [],
        },
      },
    };
  },

  computed: {
    classes: function (): NurseryClassResponse[] {
      return classModule.classes;
    },
  },

  methods: {
    async listClasses() {
      this.isLoading = true;
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId) {
        await classModule
          .listClass({
            nurseryId,
          })
          .catch();
      }
      this.isLoading = false;
    },
    async listDiarySetting() {
      this.isLoading = true;
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId) {
        const response = await diarySettingModule
          .listDiarySetting({
            nurseryId,
          })
          .catch();
        if (response) {
          this.input.classDiaryConfirmation.targetClassIds =
            response.classDiaryConfirmation.targetClasses.map((c) => {
              return c.classId;
            });
          this.input.classDiaryConfirmation.targetAges =
            response.classDiaryConfirmation.targetAges;
          this.input.schoolDiaryConfirmation.targetClassIds =
            response.schoolDiaryConfirmation.targetClasses.map((c) => {
              return c.classId;
            });
        }
      }
      this.isLoading = false;
    },
    async updateDiarySetting() {
      this.isLoading = true;
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId) {
        const response = await diarySettingModule
          .updateDiarySetting({
            nurseryId,
            ...this.input,
          })
          .catch();
        if (response) {
          alert("保存しました");
          await this.listDiarySetting();
        }
      }
      this.isLoading = false;
    },
  },
});
</script>
